import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';

const CopyPreviousEntryDialog = (props) => {
  const { open, onClose, onWithHours, onWithoutHours } = props;

  const handleCancel = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleWithHours = async () => {
    if (onWithHours) {
      await onWithHours();
    }
    if (onClose) {
      onClose();
    }
  };

  const handleWithoutHours = async () => {
    if (onWithoutHours) {
      await onWithoutHours();
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          Copy timecard line items from previous day ...
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleWithoutHours}
        >
          Without Hours
        </Button>
        <Button variant="contained" color="primary" onClick={handleWithHours}>
          With Hours
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CopyPreviousEntryDialog;
